import React, { useState } from "react";
import { GRUPOS_CAT, CONTACTO_INIT, TOKEN_SUNAT, lbl, inp } from "./constants";
import { SectionTitle } from "./helpers";

export default function FormProveedor({ form, setForm, onSubmit, onCancel, editId }) {
  const [customCat,      setCustomCat]      = useState("");
  const [newCont,        setNewCont]        = useState(CONTACTO_INIT);
  const [mostrarFrmCont, setMostrarFrmCont] = useState(false);
  const [buscandoRuc,    setBuscandoRuc]    = useState(false);
  const [rucMsg,         setRucMsg]         = useState("");

  const handleChange = e => {
    setForm(f => ({ ...f, [e.target.name]: e.target.value }));
    if (e.target.name === "ruc") setRucMsg("");
  };

  const buscarRUC = async () => {
    const num = (form.ruc || "").replace(/\D/g, "");
    if (num.length !== 11) { setRucMsg("⚠ Ingresa un RUC de 11 dígitos"); return; }

    const cacheKey = `sunat_${num}`;
    try {
      const cached = localStorage.getItem(cacheKey);
      if (cached) { aplicarResultado(JSON.parse(cached), num); return; }
    } catch {}

    setBuscandoRuc(true);
    setRucMsg("Consultando SUNAT...");
    const apiUrl = `https://dniruc.apisperu.com/api/v1/ruc/${num}?token=${TOKEN_SUNAT}`;

    const parsear = async (res) => {
      if (!res.ok) throw new Error("HTTP error");
      const json = await res.json();
      if (!json || typeof json !== "object") throw new Error("Sin datos");
      return json;
    };

    // apisperu.com permite CORS directo (Access-Control-Allow-Origin: *)
    let data = null;
    try {
      data = await fetch(apiUrl, { signal: AbortSignal.timeout(10000) }).then(parsear);
    } catch {
      setRucMsg("❌ Sin conexión a SUNAT. Intenta nuevamente.");
      setBuscandoRuc(false);
      return;
    }

    if (data?.razonSocial) {
      try { localStorage.setItem(cacheKey, JSON.stringify(data)); } catch {}
    }
    aplicarResultado(data, num);
    setBuscandoRuc(false);
  };

  const aplicarResultado = (data) => {
    if (data?.razonSocial) {
      setForm(f => ({ ...f, nombre: data.razonSocial, direccion: data.direccion || f.direccion }));
      setRucMsg(`✅ ${data.razonSocial}`);
    } else {
      setRucMsg("❌ RUC no encontrado en SUNAT");
    }
  };

  const toggleCat = (cat) => setForm(f => ({
    ...f,
    categorias: f.categorias.includes(cat)
      ? f.categorias.filter(c => c !== cat)
      : [...f.categorias, cat],
  }));

  const agregarCustomCat = () => {
    const cat = customCat.trim();
    if (!cat) return;
    if (!form.categorias.includes(cat)) setForm(f => ({ ...f, categorias: [...f.categorias, cat] }));
    setCustomCat("");
  };

  const agregarContacto = () => {
    if (!newCont.nombre.trim()) return;
    setForm(f => ({ ...f, contactos: [...f.contactos, { ...newCont }] }));
    setNewCont(CONTACTO_INIT);
    setMostrarFrmCont(false);
  };

  const eliminarContacto = (idx) =>
    setForm(f => ({ ...f, contactos: f.contactos.filter((_, i) => i !== idx) }));

  return (
    <form onSubmit={onSubmit} className="form-enter" style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 14, padding: 24 }}>
      <p style={{ fontSize: 12, fontWeight: 700, color: "#2563eb", marginBottom: 20, textTransform: "uppercase", letterSpacing: "0.06em" }}>
        {editId ? "Editar proveedor" : "Nuevo proveedor"}
      </p>

      <SectionTitle>Datos generales</SectionTitle>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14, marginBottom: 22 }}>

        <div style={{ gridColumn: "1/-1" }}>
          <label style={lbl}>Nombre comercial *
            <span style={{ fontWeight: 400, color: "#94a3b8", marginLeft: 6 }}>
              (como lo conoces o lo llamas en el día a día)
            </span>
          </label>
          <input
            name="nombreComercial"
            value={form.nombreComercial || ""}
            onChange={handleChange}
            required
            placeholder="Ej: KAMASA, Pavco, Aceros Arequipa..."
            style={inp}
          />
        </div>

        <div style={{ gridColumn: "1/-1" }}>
          <label style={lbl}>RUC
            <span style={{ fontWeight: 400, color: "#94a3b8", marginLeft: 6 }}>
              (autocompleta razón social y dirección desde SUNAT)
            </span>
          </label>
          <div style={{ display: "flex", gap: 8 }}>
            <input
              name="ruc"
              value={form.ruc || ""}
              onChange={handleChange}
              onKeyDown={e => { if (e.key === "Enter") { e.preventDefault(); buscarRUC(); } }}
              placeholder="20123456789"
              maxLength={11}
              style={{ ...inp, flex: 1 }}
            />
            <button
              type="button"
              onClick={buscarRUC}
              disabled={buscandoRuc}
              style={{
                padding: "9px 16px", borderRadius: 8, border: "none",
                cursor: buscandoRuc ? "not-allowed" : "pointer",
                background: buscandoRuc ? "#e2e8f0" : "#2563eb",
                color: buscandoRuc ? "#94a3b8" : "#fff",
                fontSize: 13, fontWeight: 600, whiteSpace: "nowrap", flexShrink: 0,
              }}
            >
              {buscandoRuc ? "Buscando..." : "🔍 Buscar"}
            </button>
          </div>
          {rucMsg && (
            <div style={{
              fontSize: 11, marginTop: 5, padding: "5px 10px", borderRadius: 6,
              background: rucMsg.startsWith("✅") ? "#E1F5EE" : rucMsg.startsWith("⚠") ? "#FEF9C3" : "#FCEBEB",
              color:      rucMsg.startsWith("✅") ? "#0F6E56" : rucMsg.startsWith("⚠") ? "#854F0B" : "#A32D2D",
            }}>
              {rucMsg}
            </div>
          )}
        </div>

        <div style={{ gridColumn: "1/-1" }}>
          <label style={lbl}>Razón social
            <span style={{ fontWeight: 400, color: "#94a3b8", marginLeft: 6 }}>
              (se autocompleta con el RUC)
            </span>
          </label>
          <input
            name="nombre"
            value={form.nombre || ""}
            onChange={handleChange}
            placeholder="Se rellena automáticamente al buscar el RUC"
            style={{ ...inp, background: form.nombre ? "#F0FDF8" : "#fff" }}
          />
        </div>

        <div>
          <label style={lbl}>Ciudad</label>
          <input name="ciudad" value={form.ciudad || ""} onChange={handleChange} placeholder="Lima" style={inp} />
        </div>
        <div style={{ gridColumn: "1/-1" }}>
          <label style={lbl}>Dirección</label>
          <input name="direccion" value={form.direccion || ""} onChange={handleChange} placeholder="Av. Industrial 123, Ate Vitarte" style={inp} />
        </div>
        <div>
          <label style={lbl}>Sitio web</label>
          <input name="website" value={form.website || ""} onChange={handleChange} placeholder="www.proveedor.pe" style={inp} />
        </div>
        <div>
          <label style={lbl}>Calificación</label>
          <select name="calificacion" value={form.calificacion} onChange={handleChange} style={{ ...inp, cursor: "pointer" }}>
            {["5","4","3","2","1"].map(n => (
              <option key={n} value={n}>{"★".repeat(n)}{"☆".repeat(5-n)} ({n})</option>
            ))}
          </select>
        </div>
        <div>
          <label style={lbl}>Plazo entrega (días)</label>
          <input name="plazoDias" type="number" value={form.plazoDias} onChange={handleChange} placeholder="3" style={inp} />
        </div>
        <div>
          <label style={lbl}>Crédito (días)</label>
          <input name="creditoDias" type="number" value={form.creditoDias} onChange={handleChange} placeholder="30" style={inp} />
        </div>
      </div>

      <SectionTitle>Categorías de materiales que provee</SectionTitle>
      <div style={{ marginBottom: 22, marginTop: 10 }}>
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 10 }}>
          <select
            value=""
            onChange={e => { if (e.target.value) { toggleCat(e.target.value); } }}
            style={{ ...inp, maxWidth: 280, cursor: "pointer" }}
          >
            <option value="">+ Seleccionar categoría...</option>
            {GRUPOS_CAT.map(g => (
              <optgroup key={g.grupo} label={`── ${g.grupo}`}>
                {g.items
                  .filter(c => !form.categorias.includes(c))
                  .map(c => <option key={c} value={c}>{c}</option>)}
              </optgroup>
            ))}
          </select>

          <input
            value={customCat}
            onChange={e => setCustomCat(e.target.value)}
            onKeyDown={e => { if (e.key === "Enter") { e.preventDefault(); agregarCustomCat(); } }}
            placeholder="Otra categoría..."
            style={{ ...inp, maxWidth: 180, fontSize: 12 }}
          />
          <button type="button" onClick={agregarCustomCat}
            style={{ padding: "9px 14px", background: "#EEF2FF", color: "#3A3C7A", border: "1.5px solid #c7d2fe", borderRadius: 8, fontSize: 12, fontWeight: 600, cursor: "pointer", whiteSpace: "nowrap" }}>
            + Agregar
          </button>
        </div>

        {form.categorias.length > 0 ? (
          <div style={{ display: "flex", gap: 6, flexWrap: "wrap", padding: "10px 12px", background: "#f8fafc", borderRadius: 8, border: "1px solid #e2e8f0" }}>
            {form.categorias.map(c => (
              <span key={c} style={{ display: "inline-flex", alignItems: "center", gap: 5, fontSize: 11, fontWeight: 600, padding: "4px 10px", borderRadius: 6, background: "#EEF2FF", color: "#3A3C7A" }}>
                {c}
                <button type="button" onClick={() => toggleCat(c)}
                  style={{ background: "none", border: "none", cursor: "pointer", color: "#6366f1", fontSize: 13, padding: 0, lineHeight: 1, fontWeight: 700 }}>
                  ×
                </button>
              </span>
            ))}
          </div>
        ) : (
          <div style={{ fontSize: 11, color: "#94a3b8", padding: "8px 12px", background: "#f8fafc", borderRadius: 8, border: "1px dashed #e2e8f0" }}>
            Sin categorías. Usa el selector o escribe una personalizada.
          </div>
        )}
      </div>

      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 10 }}>
        <SectionTitle style={{ margin: 0 }}>Contactos / Asesores por zona</SectionTitle>
        <button type="button" onClick={() => setMostrarFrmCont(v => !v)} style={{
          fontSize: 11, fontWeight: 600, padding: "5px 12px", borderRadius: 8,
          background: "#EEF2FF", color: "#3A3C7A", border: "none", cursor: "pointer",
        }}>
          {mostrarFrmCont ? "Cancelar" : "+ Añadir contacto"}
        </button>
      </div>

      {mostrarFrmCont && (
        <div style={{ background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 10, padding: 14, marginBottom: 12 }}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
            <div>
              <label style={lbl}>Nombre *</label>
              <input value={newCont.nombre} onChange={e => setNewCont(c => ({ ...c, nombre: e.target.value }))} placeholder="Ej: Juan Ríos" style={inp} />
            </div>
            <div>
              <label style={lbl}>Cargo / Rol</label>
              <input value={newCont.cargo} onChange={e => setNewCont(c => ({ ...c, cargo: e.target.value }))} placeholder="Ej: Asesor comercial" style={inp} />
            </div>
            <div>
              <label style={lbl}>Zona</label>
              <input value={newCont.zona} onChange={e => setNewCont(c => ({ ...c, zona: e.target.value }))} placeholder="Ej: Lima Norte" style={inp} />
            </div>
            <div>
              <label style={lbl}>Teléfono</label>
              <input value={newCont.telefono} onChange={e => setNewCont(c => ({ ...c, telefono: e.target.value }))} placeholder="987-654-321" style={inp} />
            </div>
            <div style={{ gridColumn: "1/-1" }}>
              <label style={lbl}>Email</label>
              <input value={newCont.email} onChange={e => setNewCont(c => ({ ...c, email: e.target.value }))} placeholder="juan@proveedor.pe" style={inp} />
            </div>
          </div>
          <button type="button" onClick={agregarContacto} style={{
            marginTop: 10, padding: "8px 16px", background: "#3A3C7A", color: "#fff",
            border: "none", borderRadius: 8, fontSize: 12, fontWeight: 600, cursor: "pointer",
          }}>
            Añadir contacto
          </button>
        </div>
      )}

      {form.contactos.length > 0 && (
        <div style={{ display: "flex", flexDirection: "column", gap: 6, marginBottom: 18 }}>
          {form.contactos.map((c, i) => (
            <div key={i} style={{ display: "flex", alignItems: "center", gap: 10, background: "#fff", border: "0.5px solid #e2e8f0", borderRadius: 8, padding: "8px 12px" }}>
              <div style={{ flex: 1, fontSize: 12, color: "#1e293b" }}>
                <strong>{c.nombre}</strong>
                {c.cargo  && <span style={{ color: "#64748b" }}> · {c.cargo}</span>}
                {c.zona   && <span style={{ color: "#854F0B", fontWeight: 600 }}> 📍{c.zona}</span>}
                {c.telefono && <span style={{ color: "#94a3b8" }}> · {c.telefono}</span>}
              </div>
              <button type="button" onClick={() => eliminarContacto(i)} style={{
                fontSize: 10, padding: "2px 7px", borderRadius: 4, background: "#fee2e2",
                color: "#991b1b", border: "none", cursor: "pointer", fontWeight: 600,
              }}>✕</button>
            </div>
          ))}
        </div>
      )}

      <div style={{ marginBottom: 18 }}>
        <label style={lbl}>Notas</label>
        <textarea name="notas" value={form.notas} onChange={handleChange} rows={2}
          placeholder="Condiciones especiales, días de atención, descuentos por volumen..."
          style={{ ...inp, resize: "vertical" }} />
      </div>

      <div style={{ display: "flex", gap: 10 }}>
        <button type="submit" style={{ flex: 1, padding: "10px 0", background: "#1e3a5f", color: "#fff", border: "none", borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: "pointer" }}>
          {editId ? "Guardar cambios" : "Crear proveedor"}
        </button>
        <button type="button" onClick={onCancel} style={{ padding: "10px 18px", border: "1px solid #e2e8f0", borderRadius: 8, background: "#fff", fontSize: 13, cursor: "pointer", color: "#475569" }}>
          Cancelar
        </button>
      </div>
    </form>
  );
}
